module.exports = __webpack_public_path__ + "static/media/l2.84efef01.jpg";